import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { style: {"padding":"20px"} }
const _hoisted_5 = { style: {"padding":"10px","background-color":"#FAFAFA","text-align":"center"} }

import { ref, reactive } from 'vue'
import { layer } from '@layui/layer-vue'
import { addDividedIntoAgent, allDividedIntoGeneralAgent, disableUsers ,adminOneClickLogin,allAdminDividedIntoAgent} from '../../api'
import { setToken,setUserName } from '../../utils/auth' 


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const copyToClipboard=(text:any)=> {
  const textarea = document.createElement('textarea');
    textarea.value = text;
    // 将 textarea 添加到 body 中
    document.body.appendChild(textarea);
    // 选中 textarea 中的内容
    textarea.select();
    // 执行复制命令
    document.execCommand('copy');
    // 移除 textarea 元素
    document.body.removeChild(textarea);
    layer.msg('复制成功')
}




//一键登录
const  oneClickLogin=(row: any)=>{ 
  var data={"key":row.userId}; 
  adminOneClickLogin(JSON.stringify(data)).then((res: any) => {
    if (res!=""&&res.code == 0) { 
            setUserName(row.userName);
            setToken(res.data);
            layer.msg("登录成功", { icon : 1, time: 1000})
            window.location.reload();
        } 
      })
 
}



//代理信息

const  isGeneralAgent=ref(false); 
  
const agentMyUserActivity = reactive({ 
  userName: "", 
  proportion: 0, 
  numberSubagents: 0, 
  visitsToday: 0 ,
  totalVisits: 0, 
  todayIp: 0, 
  totalIp: "", 
  totalDowds: 0, 
  dowdsToday:0,
  inviteToday: 0, 
  totalInvite: 0, 
  registerToday: 0, 
  totalRegister: 0, 
  open: 0, 
  closed: 0, 
  threeDays: 0, 
  sevenDays: 0, 
  thirtyDays: 0, 
  univalent:0,
  closedTotalDowds:0,
  closedTotalInvite:0,
  closedTotalRegister:0,
  userId:"",

   

});




  const check = (row: any) => {  
     
    agentMyUserActivity.userId=row.userId;

      isGeneralAgent.value=true; 
      var data = { "key": row.userId };
      geallAdminDividedIntoAgent();
  

}

const dataSourceAgent = ref([]);
const pageAgent = reactive({ current: 1, limit: 10, total: 0 });

const columnsAgent = ref([
    { title: "账号", key: "userName", align: "center",width: "100px" },
    { title: "推广地址", key: "invitationCode", align: "center" , customSlot: "invitationCode",width: "90px"},  
    { title: "分成比例", key: "proportion", align: "center" },
    { title: "今预览", key: "visitsToday", align: "center"},
    { title: "总预览", key: "totalVisits", align: "center"},
    { title: "今ip", key: "todayIp", align: "center"},
    { title: "总ip", key: "totalIp", align: "center"},
    { title: "今注册", key: "registerToday", align: "center"},
    { title: "总注册", key: "totalRegister", align: "center"},
    { title: "今充值", key: "rechargeToday", align: "center" },
    { title: "总充值", key: "totalRecharge", align: "center" },
    { title: "今收益", key: "todayEarnings", align: "center" },
    { title: "总收益", key: "totalRevenue", align: "center" },
    { title: "余额", key: "balance", align: "center" },   
  ]);


  const geallAdminDividedIntoAgent = () => { 
  var data = { "page": pageAgent.current, "limit": pageAgent.limit, "keyWord": agentMyUserActivity.userId };
  allAdminDividedIntoAgent(JSON.stringify(data)).then((res: any) => {
  
    if (res != "" && res.code == 0) {
      dataSourceAgent.value = res.data;
      pageAgent.total = res.count;
    } else {
      dataSourceAgent.value = [];
      pageAgent.total = 0;
    }
  })
}













const search = reactive({
    key: "",
})


const loading = ref(false);

const dataSource = ref([]);

const selectedKeys = ref([]);

const page = reactive({ current: 1, limit: 10, total: 0 });

const columns = ref([
    { title: "账号", key: "userName", align: "center" },
    { title: "推广地址", key: "invitationCode", align: "center" , customSlot: "invitationCode",width: "90px"},  
    { title: "分成类型", key: "verify", align: "center", customSlot: "verify", ellipsisTooltip: true, },
    { title: "分成比例", key: "proportion", align: "center" },
    { title: "代理人数", key: "numberSubagents", align: "center" }, 
    { title: "今预览", key: "visitsToday", align: "center"},
    { title: "总预览", key: "totalVisits", align: "center"},
    { title: "今ip", key: "todayIp", align: "center"},
    { title: "总ip", key: "totalIp", align: "center"},
    { title: "今注册", key: "registerToday", align: "center"},
    { title: "总注册", key: "totalRegister", align: "center"},
    { title: "今充值", key: "rechargeToday", align: "center" },
    { title: "总充值", key: "totalRecharge", align: "center" },
    { title: "今收益", key: "todayEarnings", align: "center" },
    { title: "总收益", key: "totalRevenue", align: "center" },
    { title: "余额", key: "balance", align: "center" },
    { title: "状态", key: "state", align: "center", customSlot: "state" },
    { title: "U地址", key: "uaddress", align: "center" },
    
    { title: "备注", key: "generalRemark", align: "center" }, 
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center", width: "200px" }
]);


const getAllAdminUser = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit, "key": search.key };
    allDividedIntoGeneralAgent(JSON.stringify(data)).then((res: any) => {
        loading.value = false;
        if (res != "" && res.code == 0) {
            dataSource.value = res.data;
            page.total = res.count;
        } else {
            dataSource.value = [];
            page.total = 0;
        }
    })
}
//获取数据
getAllAdminUser();


const change = (page: any) => {
    getAllAdminUser();
}

const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
}

//禁用或者开启
const changedelFlag = (row: any) => {
    var data = { "key": row.userId, "id": row.state };
    disableUsers(JSON.stringify(data)).then((res: any) => {
        if (res != "" && res.code == 0) {
            getAllAdminUser();
            layer.msg("操作成功", { time: 1000, icon: 1 });
        }
    })
}

//查询接口
const searchUser = () => {
    page.current = 1;
    getAllAdminUser();
}



const agent = reactive({
    userId: "",
    userName: "",
    password: "",
    univalent: "", 
    proportion: "",
    generalRemark: "",
    withinDays:"",
    verify: "0"
})


const updateUser = (row: any) => {
    agent.userId = row.userId;
    agent.userName = row.userName;
    agent.password = ""; 
    agent.univalent = row.univalent;
    agent.proportion = row.proportion;
    agent.verify = row.verify;
    agent.withinDays = row.withinDays;

    


    agent.generalRemark = row.generalRemark;

    isDisabled.value = true;
    visible11.value = !visible11.value;
}

const layFormRef11 = ref();

const visible11 = ref(false);

const isDisabled = ref(false);

const changeVisible11 = () => {
    agent.userId = "";
    agent.userName = "";
    agent.password = "";
    agent.univalent = ""; 
    agent.proportion = "";
    agent.generalRemark = "";
    agent.withinDays ="";

    agent.verify = "0";
    isDisabled.value = false;
    visible11.value = !visible11.value;
}

const action11 = ref([
    {
        text: "确认",
        callback: () => {
            addDividedIntoAgent(JSON.stringify(agent)).then((res: any) => {
                if (res != "" && res.code == 0) {
                    getAllAdminUser();
                    visible11.value = false;
                    layer.msg("操作成功", { time: 1000, icon: 1 });
                }
            })
        }
    },
    {
        text: "取消",
        callback: () => {
            visible11.value = false;

        }
    }
])

 


return (_ctx: any,_cache: any) => {
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_switch = _resolveComponent("lay-switch")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "代理账号",
                      prop: "username",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_input, {
                          modelValue: search.key,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.key) = $event)),
                          placeholder: "请输入账号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_lay_button, {
                    size: "sm",
                    onClick: changeVisible11,
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_switch, {
                      "model-value": row.state == 0 ? true : false,
                      onChange: ($event: any) => (changedelFlag(row)),
                      "onswitch-text": "正常",
                      "unswitch-text": "禁用"
                    }, null, 8, ["model-value", "onChange"])
                  ]),
                  invitationCode: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (copyToClipboard(row.invitationCode))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("复制链接")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (check(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下级")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "primary",
                      onClick: ($event: any) => (updateUser(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (oneClickLogin(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("一键登录")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  verify: _withCtx(({ row }) => [
                    (row.verify == '1')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 首充分佣 "))
                      : (row.verify == '2')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " 长期分佣 "))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['450px', '630px'],
      btn: action11.value,
      title: "添加/修改"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_lay_form, {
            model: agent,
            ref_key: "layFormRef11",
            ref: layFormRef11,
            pane: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "账户",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.userName,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((agent.userName) = $event)),
                    disabled: isDisabled.value,
                    placeholder: "请输入账号"
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((agent.password) = $event)),
                    type: "password",
                    placeholder: "无需修改请置空"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "分成方式",
                prop: "verifyArr"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: agent.verify,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((agent.verify) = $event)),
                    multiple: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lay_select_option, {
                        value: "1",
                        label: "首充分佣"
                      }),
                      _createVNode(_component_lay_select_option, {
                        value: "2",
                        label: "长期分佣"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "天数",
                prop: "withinDays"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.withinDays,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((agent.withinDays) = $event)),
                    placeholder: "判断多少天之内是老用户"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "分成比例",
                prop: "proportion"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: agent.proportion,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((agent.proportion) = $event)),
                    placeholder: "请输入分成比例（百分比）"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "generalRemark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: agent.generalRemark,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((agent.generalRemark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"]),
    _createVNode(_component_lay_layer, {
      modelValue: isGeneralAgent.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((isGeneralAgent).value = $event)),
      shade: false,
      area: ['850px', '630px'],
      title: "下级信息"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_lay_row, { space: "10" }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_table, {
                page: pageAgent,
                height: '100%',
                columns: columnsAgent.value,
                loading: loading.value,
                "data-source": dataSourceAgent.value,
                "selected-keys": selectedKeys.value,
                "onUpdate:selectedKeys": _cache[9] || (_cache[9] = ($event: any) => ((selectedKeys).value = $event)),
                onChange: change,
                onSortChange: sortChange
              }, {
                state: _withCtx(({ row }) => [
                  _createVNode(_component_lay_switch, {
                    "model-value": row.state == 0 ? true : false,
                    onChange: ($event: any) => (changedelFlag(row)),
                    "onswitch-text": "正常",
                    "unswitch-text": "禁用"
                  }, null, 8, ["model-value", "onChange"])
                ]),
                invitationCode: _withCtx(({ row }) => [
                  _createVNode(_component_lay_button, {
                    size: "xs",
                    type: "primary",
                    onClick: ($event: any) => (copyToClipboard(row.invitationCode))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("复制链接")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})